export default __webpack_public_path__ + "static/media/5.502998a9.webp";